import { render, staticRenderFns } from "./ManageVip.vue?vue&type=template&id=10b5daaa"
import script from "./ManageVip.vue?vue&type=script&lang=js"
export * from "./ManageVip.vue?vue&type=script&lang=js"
import style0 from "./ManageVip.vue?vue&type=style&index=0&id=10b5daaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports